import React from 'react';
import { HeadphonesIcon } from 'lucide-react';
import { toast } from 'sonner';
export function PlatformFooterBar() {
  return <div className="fixed bottom-14 left-1/2 -translate-x-1/2 w-full max-w-[390px] bg-white/95 backdrop-blur border-t border-slate-100 px-4 h-9 flex items-center justify-between z-30" data-id="element-97">
      <div className="text-[11px] text-slate-500" data-id="element-98">
        指南者留学 · 让留学链接多元人生
      </div>
      <button onClick={() => toast('客服已为您接入，请稍候…', {
      icon: '💬'
    })} className="flex items-center gap-1 text-[11px] text-blue-600 font-medium" aria-label="联系客服" data-id="element-99">
        <HeadphonesIcon size={14} data-id="element-100" /> 客服
      </button>
    </div>;
}